import { render, staticRenderFns } from "./ReminderRedirect.vue?vue&type=template&id=0688668f&"
import script from "./ReminderRedirect.vue?vue&type=script&lang=js&"
export * from "./ReminderRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports